const productLabelExceptionList = [
  'Jira Service Management',
  'Jira Service Management project admin',
  'Jira Align',
  'Jira Product Discovery',
];

export const transformTaxonomyLabel = (input: string, maxLength: number): string[] => {
  let words = (input.charAt(0).toUpperCase() + input.slice(1).toLowerCase()).split(' ');
  const result = [];
  let currentLine = '';
  const exceptionLabel = productLabelExceptionList.find((product) => product.toLowerCase() === input.toLowerCase());

  if (exceptionLabel) {
    words = exceptionLabel.split(' ');
  }

  for (const word of words) {
    if (currentLine.length === 0) {
      currentLine = word;
    } else if ((currentLine + ' ' + word).length <= maxLength) {
      currentLine += ' ' + word;
    } else {
      result.push(currentLine);
      currentLine = word;
    }
  }

  if (currentLine) {
    result.push(currentLine);
  }

  return result;
};
